import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core'

import { TranslateService } from '../../services/translate';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent implements OnChanges, OnDestroy {
  @Input() isOpen: boolean;
  @Input() hasTransparentOverlay = false;
  @Input() hasTrappedFocus = false;
  @Input('size')
  set size(value: number | string) {
    if (typeof value === 'number') this._size = value;
    else {
      const parsed = Number(value);
      if (isNaN(parsed)) {
        throw new Error(`SpinnerComponent.size must be a valid parseable number, got "${value}" instead`);
      }
      this._size = parsed;
    }
  }
  get size() {
    return this._size;
  }
  @Input() useOverlay = true;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter();

  private announceInterval: NodeJS.Timer;
  private _size = 50;

  constructor(private liveAnnouncer: LiveAnnouncer, private translateService: TranslateService) {}

  announcePageLoading() {
    this.translateService.translate('ngx-shared-please-wait-the-page-is-loading').subscribe((loading) => {
      if (!loading) {
        return;
      }
      this.liveAnnouncer.announce(loading, 'assertive');
      this.announceInterval = setInterval(() => {
        this.liveAnnouncer.announce(loading, 'assertive');
      }, 5000);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isOpen) {
      if (changes.isOpen.currentValue) {
        this.announcePageLoading();
      } else {
        this.liveAnnouncer.clear();
        clearInterval(this.announceInterval);
      }
    }
  }

  ngOnDestroy() {
    clearInterval(this.announceInterval);
  }

  overlayClose() {
    this.close.emit();
  }
}
